/****
 Global
 /

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount) {
    return `$${Math.round(parseFloat(amount) / 100)}`;
}

//image resizer
function imageResizer(url, size) {
    let lastPeriod = url.lastIndexOf(".");
    return `${url.substring(0, lastPeriod)}_${size}${url.substring(lastPeriod)}`;
}


// convert date
// https://stackoverflow.com/a/39924394
function humanizeDate(date_str) {
    const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const date_arr = date_str.split('-');
    return month[Number(date_arr[1]) - 1] + " " + Number(date_arr[2]) + ", " + date_arr[0]
}

// convert date to 2022-04-03;
function returnYMD(date) {
    let getYear = date.toLocaleString("default", {year: "numeric"});
    let getMonth = date.toLocaleString("default", {month: "2-digit"});
    let getDay = date.toLocaleString("default", {day: "2-digit"});
    return getYear + "/" + getMonth + "/" + getDay;
}


/
 * Cycle Announcemnts
 */

new Swiper("#announcement", {
    loop: true,
    autoplay: {
        delay: 1,
        disableOnInteraction: false
    },
    slidesPerView: 'auto',
    speed: window.innerWidth > 800 ? 20000 : 8000,
})


/**
 Auto scroll
 /

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("scroll_to")) {
    const element = document.querySelector(urlParams.get("scroll_to"));
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top ,
        })
    }
}